import React from "react";
import { Link } from "react-router-dom";

const CookiesPolicy = () => {
  return (
    <div className="about-area-1 space">
      <div className="about1-shape-img shape-mockup">
        <img
          className="about1-shape-img-1 spin"
          src="assets/img/normal/about_shape1-2.svg"
          alt="LealChapayPintura.com"
        />
        <img
          className="about1-shape-img-2 spin2"
          src="assets/img/normal/about_shape1-1.svg"
          alt="LealChapayPintura.com"
        />
      </div>
      <div className="container">
        <div className="row align-items-center justify-content-between flex-row-reverse">
          <div className="col-xxl-12">
            <div className="about-content-wrap">
              <div className="title-area me-xl-50 mb-30">
                <span className="sub-title">Política de Cookies</span>
                <div className="sec-text">
                  <p>
                    En cumplimiento con el deber de información recogido en el
                    apartado 2º del artículo 22 de la Ley 34/2002, de 11 de Julio, de
                    Servicios de la Sociedad de la Información y del Comercio Electrónico,
                    la presente política de cookies tiene por finalidad informarle de
                    manera clara y precisa sobre las cookies que se utilizan en la página
                    web de Leal Chapa y Pintura SL.
                  </p>

                  <p>
                    <strong>¿Qué son las cookies?</strong>
                  </p>
                  <p>
                    Una cookie es un fichero de pequeño tamaño que los sitios web envían al
                    navegador y se descargan en su ordenador. Las cookies permiten que la
                    página web almacene y recupere la información sobre su visita, como su
                    idioma preferido y otras opciones, con el fin de mejorar los servicios que
                    se ofrecen y contribuir a tener una mejor experiencia de navegación para
                    el usuario.
                  </p>

                  <p>
                    <strong>Tipos de cookies</strong>
                  </p>
                  <p>
                    En función de quién gestione el dominio desde donde se envían las cookies y se
                    traten los datos, se distinguirá entre cookies propias y cookies de terceros.
                  </p>
                  <p>
                    Las cookies también pueden clasificarse según el plazo de tiempo que permanezcan
                    almacenadas en el navegador del usuario, distinguiéndose entre cookies de sesión o
                    cookies persistentes.
                  </p>
                  <p>
                    Finalmente, en función de la finalidad para la que se trate la información
                    recopilada, las cookies se pueden clasificar en las siguientes categorías:
                  </p>
                  <ul>
                    <li>
                      <strong>Cookies técnicas:</strong> permiten al usuario navegar por un sitio
                      web y utilizar algunos de los servicios ofrecidos por el mismo (como, por
                      ejemplo, las que sirven para recordar los elementos integrantes de un carrito
                      de compra).
                    </li>
                    <li>
                      <strong>Cookies de personalización:</strong> permiten que el usuario acceda al
                      sitio web con unas características determinadas, como puede ser el idioma.
                    </li>
                    <li>
                      <strong>Cookies de seguridad:</strong> sirven para impedir o dificultar los
                      ataques contra el sitio web.
                    </li>
                    <li>
                      <strong>
                        Cookies de complemento para intercambiar contenidos sociales:
                      </strong>{" "}
                      los llamados plug-in, que permiten compartir contenidos en redes sociales.
                    </li>
                    <li>
                      <strong>Cookies de análisis:</strong> permiten al responsable el seguimiento
                      del comportamiento del usuario.
                    </li>
                    <li>
                      <strong>Cookies publicitarias:</strong> permiten gestionar los espacios de
                      publicidad del sitio web.
                    </li>
                    <li>
                      <strong>Cookies de publicidad comportamental:</strong> sirven para gestionar
                      los espacios de publicidad del sitio web en función de la información
                      recogida sobre el comportamiento del usuario y sus hábitos, adaptando la
                      publicidad al perfil del usuario.
                    </li>
                    <li>
                      <strong>Cookies de geolocalización:</strong> utilizadas para averiguar el país
                      dónde se encuentra el usuario.
                    </li>
                  </ul>

                  <p>
                    <strong>Autorización para el uso de cookies</strong>
                  </p>
                  <p>
                    De conformidad con el aviso de cookies que aparece en el sitio web, el usuario
                    puede consentir expresamente el uso de cookies que requieran consentimiento;
                    sin embargo, el uso de cookies técnicas o necesarias no requiere de consentimiento.
                    Sin perjuicio de todo ello, el usuario puede modificar la configuración de su
                    navegador para rechazar el uso de las cookies.
                  </p>

                  <p>
                    <strong>Cómo modificar la configuración de las cookies</strong>
                  </p>
                  <p>
                    Usted puede restringir, bloquear o borrar las cookies de Leal Chapa y Pintura
                    SLU o cualquier otra página web utilizando su navegador. En cada navegador la
                    operativa es diferente, puede encontrar cómo hacerlo en el menú de ayuda de su
                    navegador dónde se establece el procedimiento para su eliminación. Para más
                    información:
                  </p>
                  <ul>
                    <li>
                      Google Chrome:{" "}
                      <a
                        href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=es"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        https://support.google.com/chrome/answer/95647?co=GENIE.Platform=Desktop&hl=es
                      </a>
                    </li>
                    <li>
                      Mozilla Firefox:{" "}
                      <a
                        href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias
                      </a>
                    </li>
                    <li>
                      Safari:{" "}
                      <a
                        href="https://support.apple.com/es-es/guide/safari/sfri11471/mac"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        https://support.apple.com/es-es/guide/safari/sfri11471/mac
                      </a>
                    </li>
                    <li>
                      Internet Explorer:{" "}
                      <a
                        href="https://support.microsoft.com/es-es/help/278835/how-to-delete-cookie-files-in-internet-explorer"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        https://support.microsoft.com/es-es/help/278835/how-to-delete-cookie-files-in-internet-explorer
                      </a>
                    </li>
                  </ul>
                  <p>
                    Es posible que al deshabilitar las cookies la página web no funcione correctamente
                    o no pueda acceder a determinadas funciones de la misma.
                  </p>

                  <p>
                    <strong>Cookies utilizadas en la web</strong>
                  </p>
                  <p>
                    En el portal web se utilizan diferentes tipos de cookies con distintas finalidades,
                    a continuación, se enumeran las cookies empleadas:
                  </p>
                  <p>En el icono de que aparece abajo a la izquierda puede ver en tiempo real los cookies utilizados y su uso.</p>

                  <p>
                    <strong>Modificación de las condiciones</strong>
                  </p>
                  <p>
                    Leal Chapa y Pintura SL se reserva expresamente el derecho a modificar unilateralmente,
                    total o parcialmente, sin necesidad de previo aviso, la presente Política de Cookies.
                    El usuario reconoce y acepta que es su responsabilidad revisar la presente Política de
                    Cookies.
                  </p>
                </div>
              </div>
              <div className="btn-wrap mt-40">
                <Link to="/" className="btn style2">
                  Volver <i className="fas fa-arrow-left ms-2" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiesPolicy;
